module.exports = __webpack_public_path__ + "img/W-G17.043657cb.jpg";